'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFontDownload = function ContentFontDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
  );
};
ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
ContentFontDownload.displayName = 'ContentFontDownload';
ContentFontDownload.muiName = 'SvgIcon';

exports.default = ContentFontDownload;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/content/font-download.js
// module id = 272
// module chunks = 1